// extracted by mini-css-extract-plugin
module.exports = {"meals":"AvailableMeals_meals__3dpmI","meals-appear":"AvailableMeals_meals-appear__2MxC2"};